<template>
  <div class="d-flex flex-column align-items-center">
    <content-header-custom
      title="Referee"
      class="w-100 mxw-md px-10"
      includeBack
      :subTitle="subTitle"
    >
    </content-header-custom>
    <content-body-card class="w-100">
      <el-tabs v-if="loaded" v-model="activeName">
        <el-tab-pane label="Appointment" name="appointment" :lazy="true">
          <appointment v-model="appointments" @update-status="updateStatus"/>
        </el-tab-pane>
        <el-tab-pane label="Availability" name="availability" :lazy="true">
          <availability
          :referees="referees"
          :unavailabilities="unavailabilities"
          @add-unavailability="addUnavailability"
          @update-unavailability="updateUnavailability"
          @delete-unavailability="deleteUnavailability" />
        </el-tab-pane>
      </el-tabs>
    </content-body-card>
  </div>
</template>

<script>

// import _ from 'lodash';

export default {
  name: 'Profile',
  components: {
    Appointment: () => import('./components/appointment'),
    Availability: () => import('./components/availability')
  },
  props: {
    tabName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeName: this.tabName ? this.tabName : 'appointment',
      subTitle:
        'On this screen you can manage current referee role information and appointment history.',
      loaded: false,
      appointments: [],
      referees: [],
      unavailabilities: [],
    };
  },
  async mounted() {
    const resAppointments = await this.$http.get('/assemble/api/v1/portal/my-appointments');
    const resReferees = await this.$http.get('/assemble/api/v1/portal/my-referees');
    const resUnavailability = await this.$http.get('/assemble/api/v1/portal/my-unavailability');
    this.appointments = resAppointments.data.data;
    this.referees = resReferees.data.data;
    this.unavailabilities = resUnavailability.data.data;
    if (this.appointments && this.appointments.length > 0 && this.referees && this.referees.length > 0) {
      this.loaded = true;
    }
  },
  methods: {
    updateStatus(appointment) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.put('/assemble/api/v1/portal/appointment/update-status', {
        memberId: appointment.refereeId,
        appointmentId: appointment._id,
        status: appointment.status
      })
        .then(() => {
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
    },
    addUnavailability(unavailability) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post(`/assemble/api/v1/portal/referee/board/${unavailability.board}/unavailability`, unavailability)
        .then(() => {
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
    },
    updateUnavailability(unavailability) {
      const unavailabilityId = unavailability.recurringUnavailable ? unavailability.recurringUnavailable._id : unavailability.unavailable._id;
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.put(`/assemble/api/v1/portal/referee/board/${unavailability.board._id}/unavailability/${unavailabilityId}`, unavailability)
        .then(() => {
          this.$message.success('Unavailability updated successfully');
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
    },
    deleteUnavailability(unavailability) {
      const unavailabilityId = unavailability.recurringUnavailable ? unavailability.recurringUnavailable._id : unavailability.unavailable._id;
      const type = unavailability.recurringUnavailable ? 'recurring' : 'fixed';
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.delete(`/assemble/api/v1/portal/referee/${unavailability._id}/board/${unavailability.board._id}/unavailability/${unavailabilityId}`, { params: { type } })
        .then(() => {
          this.$message.success('Unavailability deleted successfully');
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
    }
  }

};
</script>

<style scoped lang="scss">
.el-date-editor,
.el-select,
.el-input {
  width: 100%;
}

.main-content {
  width: 100%;
}

.avatar-section {
  position: relative;
  display: inline-block;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  overflow: hidden;
  .upload-button {
    position: absolute;
    display: inline-block;
    background-color: rgb(45, 58, 69, 0.35);
    bottom: 0;
    right: 0;
    height: 22px;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 0.7em;
    line-height: 1.75em;
    font-family: $fontLight;
    cursor: pointer;
  }
}
</style>
